import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[validateNumber]'
})
export class ValidateNumberDirective {

  @Input('validateNumber') decimals = '';
  private check(value: string) {
      const [length, precision] = this.decimals.split('.'),
      regExpString = `^($|^[1-9][0-9]{0,${+length - 1 }})((\\.{1})([\\d]{1,${+precision}})?)?$`,
      regExpWOPrecision  = `^($|^[1-9][0-9]{0,${+length - 1 }})?$`;
      let result = '';
      if (precision) {
        result = regExpString;
      } else {
        result = regExpWOPrecision;
      }
      return String(value).match(new RegExp(result));
  }

  private run(oldValue: string) {
      setTimeout(() => {
          const currentValue: string = this.el.nativeElement.value;
          if (currentValue && !this.check(currentValue)) {
              this.control.control.patchValue(oldValue);
          }
      });
  }

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
      this.run(this.el.nativeElement.value);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
      this.run(this.el.nativeElement.value);
  }

}
